/**
 * Narrows an unknown value to a non-array object suitable for data contracts.
 */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
